import React from 'react'
import { Card, List, ListItem, ListItemText } from '@mui/material'
import { parseUnixTimestamp } from '../utils/timestampParsers'
import AvatarComponent from '../user-menu/AvatarComponent'
import Typography from '@mui/material/Typography';

const getTokenStatus = (expiryTimestamp) => {
  const currentTime = new Date();
  const expiryTime = new Date(expiryTimestamp);
  return currentTime < expiryTime ? 'Active' : 'Expired';
}

const TokenInfo = ({ isAdmin, email, exp, sid }) => {
  const expiryTimestamp = parseUnixTimestamp(exp);

  return (
    <Card elevation={0} sx={{ p: 2, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <List disablePadding dense sx={{ width: '100%', textAlign: 'center' }}>
        <ListItem>
          <ListItemText 
            primary={<AvatarComponent string={email} />} 
            primaryTypographyProps={{ mb: 1 }}
            secondary={email}
            sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}
          />
        </ListItem>
        <ListItem>
          <ListItemText 
            primary={isAdmin ? "Administrator" : "User"}
            secondary="Role"
          />
        </ListItem>
        <ListItem>
          <ListItemText 
            primary={
              <Typography fontSize='0.9em' color={getTokenStatus(expiryTimestamp) === 'Active' ? 'hsl(120, 75%, 50%)' : 'hsl(0, 100%, 50%)'}>
                {getTokenStatus(expiryTimestamp)}
                {expiryTimestamp}
              </Typography>
            }
            secondary="Session"
          />
        </ListItem>
        <ListItem>
          <ListItemText 
            primary={sid}
            secondary="Session ID"
          />
        </ListItem>
      </List>
    </Card>
  )
}

export default TokenInfo